<template>
  <div class="menuBody"  style="padding-left:25px;">
    <InstitutionalDialog  ref="InstitutionalDialog" @Visible="Visible"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="border-bottom:1px solid rgba(234, 237, 241, 1);width:100%;height:30px;margin-bottom:10px;">
                组织机构列表
            </div>
            <div style="width:150px;float:left;">
                 <el-input placeholder="请输入机构名称" size="small"   v-model="CourseName"></el-input>
            </div>
            <div style="float:left;margin-left:30px">
                <el-button type="primary" size="small" plain style="background: #246CE5;color:#fff; border-radius:9px;" v-Jurisdiction="'sys:web:office:manage:list'" @click="Inquire()">查询</el-button>
            </div>
        <el-table tooltip-effect="light"  :data="menuTree" v-loading="loading"  height="500" row-key="officeId" style="margoin-top:20px" border :default-expand-all="false" :stripe="true"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column show-overflow-tooltip prop="officeName" label="机构名称"  ></el-table-column>
      <el-table-column show-overflow-tooltip prop="areaName" label="归属区域"  ></el-table-column>
      <el-table-column show-overflow-tooltip prop="code" label="机构编码" sortable  align="center"></el-table-column>
      <el-table-column show-overflow-tooltip prop="officeType" label="机构层级"   align="center"></el-table-column>
      <el-table-column show-overflow-tooltip prop="isLog" label="备注"   align="center"></el-table-column>
      <el-table-column fixed="right" label="操作" align="center" >
        <template slot-scope="scope">
          <el-button @click="addNextMenu(scope.row)" type="success"  icon="el-icon-plus"  circle
          v-Jurisdiction="'sys:web:office:manage:add'"
                     size="small" title="添加下级"></el-button>
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small"
          v-Jurisdiction="'sys:web:office:manage:edit'"
                     title="修改"></el-button>
          <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small"
          v-Jurisdiction="'sys:web:office:manage:del'"
                     title="删除"  v-debounce></el-button>
        </template>
      </el-table-column>
    </el-table>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import InstitutionalDialog from "./InstitutionalDialog.vue"
export default {
  name: "Institutional",
  components: {InstitutionalDialog},
  data() {
    return {
        loading: false,
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        diaLogVisible: false,
        diaLogData: {
          diaLogVisible: false,
          diaLogType: '',
          paramObj: {},
          paramList: [],
        },
        menuTree:[],
        CourseName:"",
        menuL:[],
        DistrictList:[],
    }
  },
  methods: {
   Inquire(){
     this.loading = true
     this.menuList()
   },
   menuList(){
      let obj = {
        "name":this.CourseName
      }
      this.$http.post(this.$requestUrl.POST_OFFICE_LIST,obj).then((res) => {
        if(res.data.code == 200){
          let data = res.data.data
          this.loading = false
          this.menuTree = data
        }else if(res.data.data == null && res.data.data.length == 0){
          this.$message({
            type: 'warning',
            message: '暂无数据!'
          });
        }
      }).catch(() => {
        this.loading = false
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
   },
   addNextMenu(row){
     this.traverse(this.menuTree)
    //  console.log(this.DistrictList)
     this.$refs.InstitutionalDialog.parentIds = row.officeParentIds+row.officeId+","
     this.$refs.InstitutionalDialog.title = "添加下级组织机构"
     this.$refs.InstitutionalDialog.InstituVal = row.value
     this.$refs.InstitutionalDialog.parentId = row.value
     this.$refs.InstitutionalDialog.dialogVisible = true
     this.$refs.InstitutionalDialog.InstitutionList = this.menuTree
     this.$refs.InstitutionalDialog.AreaVal = row.areaName
     this.$refs.InstitutionalDialog.formLabelAlign = {}
     this.$refs.InstitutionalDialog.userTypeD = ""
     this.$refs.InstitutionalDialog.userTypeVal = ""
     this.$refs.InstitutionalDialog.gradeTypeVal = ""
     this.$refs.InstitutionalDialog.AreaList = this.DistrictList
   },
   traverse(data){
     for(let val of data){
       val.label = val.officeName
       val.value = val.officeId
       if(val.children != null){
         this.traverse(val.children)
          if(val.children.length == 0){
            delete val.children
          }
       }
     }
   },
   editMenu(row){
    this.traverse(this.menuTree)
    this.$http.get(this.$requestUrl.GET_USER_DETAILSL+row.officeId).then((res) => {
       if(res.data.code == 200){
          this.$refs.InstitutionalDialog.parentIds = row.officeParentIds
          this.$refs.InstitutionalDialog.title = "修改组织机构"
          this.$refs.InstitutionalDialog.parentId = row.officeParentId
          this.$refs.InstitutionalDialog.InstituVal = row.value
          this.$refs.InstitutionalDialog.dialogVisible = true
          this.$refs.InstitutionalDialog.InstitutionList = this.menuTree
          this.$refs.InstitutionalDialog.AreaVal = row.areaName
          this.$refs.InstitutionalDialog.formLabelAlign = res.data.data
          this.$refs.InstitutionalDialog.userTypeD = row.officeType
          this.$refs.InstitutionalDialog.gradeTypeVal = res.data.data.grade
          this.$refs.InstitutionalDialog.AreaList = this.DistrictList
       }
    })
   },
   delMenu(row){
        this.$confirm('您确认要删除当前机构, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        this.$http.delete(this.$requestUrl.DELETE_OFFICE+row.officeId).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.loading = true
          this.menuList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
        }
      })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
   },

   Visible(data){
     if(data == false){
        this.loading = true
      this.menuList()
     }
   },
   province(){
     let obj = {
       "parentCode":0
     }
      this.$http.post(this.$requestUrl.POST_AREA_LEVEL,obj).then((res) => {
        if(res.data.code == 200){
          for(let val of res.data.data){
            val.value = val.areaCode
            val.label = val.name
            val.id = val.id
          }
          this.DistrictList = res.data.data
        }
      })
   },

   

  },
  mounted() {
    this.province()
    this.menuList()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
</style>
<style>

</style>